import {SidebarSection} from 'modules/decisionsNext/hooks/sidebar/types';

import {iconUrlMap} from 'modules/decisionsNext/hooks/sidebar/iconUrlMap';

export const withUrlIcons = (sections: SidebarSection[]) => {
  return sections.map(section => {
    return {
      ...section,
      items: section.items.map(item => {
        if ('divider' in item) {
          return item;
        }

        return {
          ...item,
          icon: iconUrlMap[item.icon] || item.icon,
        };
      }),
    };
  });
};
